import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/img/common/logo.gif'


const _hoisted_1 = { class: "l-wrapper_header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("header", { class: "g-header -min" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "g-header_inner" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "g-header_logo" }, [
      /*#__PURE__*/_createElementVNode("img", {
        src: _imports_0,
        alt: "マイナビ転職AGENT"
      })
    ])
  ])
], -1)
const _hoisted_3 = [
  _hoisted_2
]

import { onMounted } from 'vue';

/// src/js/_module/_gMenu.ts

export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderLogin',
  setup(__props) {


function gMenu() {
 const gMenu2 = document.querySelectorAll(
   '.js-gMenu'
 );
 if (!gMenu2?.length) return;
 const currentUrl = window.location.pathname;
 const pathArray = currentUrl.split('/');
 let menuCurrent = '';
 const currentList = [
   {
     path: ['news'],
     class: '-home'
   },
   {
     path: ['apply'],
     class: '-id'
   },
   {
     path: ['jobsearch', 'refusal', 'refusallist'],
     class: '-search'
   },
   {
     path: ['pending'],
     class: '-fav'
   },
   {
     path: [
       'profile',
       'recommend',
       'resume',
       'sendsetting',
       'pwupdate',
       'video'
     ],
     class: '-menu'
   }
 ];
 const matched = currentList.find((item) => item.path.includes(pathArray[1]));
 if (matched) {
   menuCurrent = matched.class;
 }
 if (!pathArray[1]) menuCurrent = '-home';
 if (pathArray[1] === 'apply' && (pathArray[2] === 'form' || pathArray[2] === 'multiple')) {
   menuCurrent = '-search';
 }
 const modalFunc = (button, content, bodyFix) => {
   const is_expanded = button.getAttribute('aria-expanded') === 'true';
   button.setAttribute('aria-expanded', String(!is_expanded));
   content.setAttribute('aria-hidden', String(is_expanded));
   if (!is_expanded) {
     if (bodyFix) document.body.style.overflow = 'hidden';
     if (button.textContent?.trim() === '\u30E1\u30CB\u30E5\u30FC') {
       button.textContent = '\u3068\u3058\u308B';
     }
   } else {
     if (bodyFix) document.body.style.overflow = '';
     if (button.textContent?.trim() === '\u3068\u3058\u308B') {
       button.textContent = '\u30E1\u30CB\u30E5\u30FC';
     }
     button.focus();
   }
 };
 const modalInit = (button, content, bodyFix) => {
   button.addEventListener('click', () => {
     modalFunc(button, content, bodyFix);
   });
   content.addEventListener('click', () => {
     modalFunc(button, content, bodyFix);
   });
   const contentBody = content.querySelector(':scope > *');
   contentBody?.addEventListener('click', (event) => {
     event.stopPropagation();
   });
   const closeButtons = content.querySelectorAll(
     '.js-gMenu-close'
   );
   if (!closeButtons?.length) return;
   for (const element of Array.from(closeButtons)) {
     element.addEventListener('click', () => {
       modalFunc(button, content, bodyFix);
     });
   }
 };
 for (const element of Array.from(gMenu2)) {
   const gMenuContent = element.querySelector(
     '.js-gMenu-content'
   );
   if (!gMenuContent) return;
   const gMenuButton = element.querySelector(
     '.js-gMenu-button'
   );
   if (!gMenuButton) return;
   modalInit(gMenuButton, gMenuContent, true);
   const logoutContent = element.querySelector(
     '.js-gMenu-logout-content'
   );
   if (!logoutContent) return;
   const logoutButton = element.querySelector(
     '.js-gMenu-logout-button'
   );
   if (!logoutButton) return;
   modalInit(logoutButton, logoutContent);
   const gMenuItems = element.querySelectorAll(
     '.g-menu_button'
   );
   if (gMenuItems) {
     for (const item of Array.from(gMenuItems)) {
       const classList = Array.from(item.classList).filter(
         (className) => className !== 'g-menu_button'
       );
       if (classList.includes(menuCurrent)) {
         item.classList.add('is-active');
       }
     }
   }
 }
}

onMounted(() => {
  gMenu();
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_3))
}
}

})